import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketHubspotControlComponent } from './ticket-hubspot-control.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [TicketHubspotControlComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [TicketHubspotControlComponent],
})
export class TicketHubspotControlModule {}
